/**
 * Defines constants for component type names used in the UI framework.
 */
export class ComponentTypes {
	/**
	 * View component type - represents a screen or page in the application.
	 */
	static readonly View = 'View';

	static readonly StackContainer = 'StackContainer';

	static readonly ReactComponentHost = 'ReactComponentHost';
}
